<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header v-slot="{ open }">
        <v-row no-gutters>
          <v-col cols="4"> Filtro por fecha </v-col>
          <v-col cols="8" class="text--secondary">
            <v-fade-transition leave-absolute>
              <span v-if="open">Seleccione el rango de fechas: </span>
              <v-row v-else no-gutters style="width: 100%">
                <v-col cols="6"> <b>Desde:</b> {{ date_start }} </v-col> <v-col cols="6"> <b>Hasta:</b> {{ date_end }} </v-col>
              </v-row>
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="space-around" no-gutters>
          <v-col cols="4">
            <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date_start" dense label="Inicio" hint="DD/MM/YYYY " prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="date1" no-title @input="menu1 = false" :max="max_star" scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date_end" dense label="Final" hint="DD/MM/YYYY " prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="date2" no-title @input="menu2 = false" :max="maxDate2" scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-checkbox dense v-model="estado" :label="`${estado ? '' : 'Ver Anulados'}`" class="mt-1"></v-checkbox>
          </v-col>
          <!-- <v-col cols="1">
            <v-tooltip bottom >
              <template #activator="{ on, attrs }">
                <v-icon class="ma-2" v-bind="attrs" @click="$emit('refrescar')" v-on="on" color="orange"> mdi-refresh </v-icon>
              </template>
              Refrescar
            </v-tooltip>
          </v-col> -->
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
export default {
  props: {
    dateStart: { type: String, default: null },
    dateEnd: { type: String, default: new Date().toISOString().substr(0, 10) },
  },
  data: (vm) => ({
    menu1: false,
    date1: new Date().toISOString().substr(0, 10),
    date_start: vm.dateStartDefault(),
    max_star: new Date().toISOString().substr(0, 10),

    menu2: false,
    date2: new Date().toISOString().substr(0, 10),
    date_end: vm.formatDate(new Date().toISOString().substr(0, 10)),

    estado: false,
  }),
  computed: {
    maxDate2() {
      return new Date().toISOString().substr(0, 10);
    },
  },
  watch: {
    date1() {
      this.date_start = this.formatDate(this.date1);
      this.$emit('update:dateStart', this.date_start);
      this.$emit('clicked');
    },
    date2() {
      this.date_end = this.formatDate(this.date2);
      this.$emit('update:dateEnd', this.date_end);
      this.$emit('clicked');
      this.max_star = this.date2;
      if (this.date1 > this.date2) {
        this.date1 = this.date2;
      }
    },
    estado() {
      this.$emit('update:status', !this.estado);
      this.$emit('clicked');
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    dateStartDefault() {
      let date = new Date();
      date.setDate(date.getDate() - 5);
      return this.formatDate(date.toISOString().substr(0, 10));
    },
    getGMTMinus4Date() {
      const date = new Date();
      const gmtMinus4Date = new Date(date.getTime() - (4 * 60 * 60 * 1000));
      return gmtMinus4Date.toISOString().substr(0, 10);
    },
  },
  mounted() {
    this.date2 = this.getGMTMinus4Date();
    let date = new Date();
    date.setDate(date.getDate() - 5);
    this.date1 = date.toISOString().substr(0, 10);
  },
};
</script>